module.exports = __webpack_public_path__ + "media/images/emblems/Coat_of_arms_of_Brislach-e49b8be395add283ac03a5990f3d3e47.svg";